import React from "react";
import { PopMenuEventProps } from "models/propTypes/menuPropTypes";

const PopMenuEvents: React.FC<PopMenuEventProps> = (props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isOpen, setIsOpen] = React.useState<boolean>(Boolean(anchorEl));
  const [isClosing, setIsClosing] = React.useState(false);

  React.useEffect(() => {
    if (isClosing) {
      setTimeout(() => {
        setIsClosing(false);
      }, 200);
    }
  }, [isClosing]);

  const closeMenu = (event?: React.MouseEvent<HTMLButtonElement>) => {
    if (!props.allowClickEventPropagation && event) {
      event.stopPropagation();
    }

    setAnchorEl(null);
    setIsClosing(true);
    setIsOpen(false);
    props.menuStateChangeCallback && props.menuStateChangeCallback(false);
  };

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!props.allowClickEventPropagation) {
      event.stopPropagation();
    }
    setAnchorEl(event.currentTarget);
    setIsOpen(true);
    props.menuStateChangeCallback && props.menuStateChangeCallback(true);
  };

  return <>{props.render(anchorEl, isOpen, openMenu, closeMenu, isClosing)}</>;
};

export default PopMenuEvents;
